<div class="flex justify-content-center w-full">
    <h1>Please wait while we process your launch request.</h1>
</div>